import { MonitorStatus } from "@oneleet/api_client";
import { getReadableText } from "@oneleet/utils";

import { VariantProps, cva } from "class-variance-authority";

const statusIndicatorVariants = cva("size-4 shrink-0", {
  variants: {
    status: {
      [MonitorStatus.BREACHING_SLA]: "stroke-ng-red-900 fill-ng-red-800",
      [MonitorStatus.ALERTING]: "stroke-ng-red-900 fill-ng-red-800",
      [MonitorStatus.PASSING]: "stroke-ng-green-900 fill-ng-green-800",
      [MonitorStatus.NO_APPLICABLE_ASSETS]:
        "fill-neutral-50 stroke-neutral-400",
      [MonitorStatus.NOT_YET_RUN]: "fill-accent-400 stroke-accent-900",
      [MonitorStatus.IGNORED]: "stroke-neutral-450 fill-neutral-300",
      [MonitorStatus.DISABLED]: "stroke-neutral-450 fill-neutral-300",
    } satisfies Record<MonitorStatus, string>,
  },
  defaultVariants: {
    status: MonitorStatus.NOT_YET_RUN,
  },
});

export type AssetStatusIndicatorProps = VariantProps<
  typeof statusIndicatorVariants
>;

export const AssetStatusIndicator = ({ status }: AssetStatusIndicatorProps) => {
  if (!status)
    throw new Error(
      "No status prop was passed to AssetStatusIndicator but is required",
    );

  return (
    <svg
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={statusIndicatorVariants({ status })}
      aria-label={getReadableText(status)}
    >
      <path
        d="M7.16892 3.52311L7.16913 3.5229C7.5993 3.09237 8.4007 3.09237 8.83087 3.5229L8.83108 3.52311L12.9769 7.66892L12.9771 7.66913C13.4076 8.0993 13.4076 8.9007 12.9771 9.33087L12.9769 9.33108L8.83108 13.4769L8.83087 13.4771C8.4007 13.9076 7.5993 13.9076 7.16913 13.4771L7.16892 13.4769L3.02311 9.33108L3.0229 9.33087C2.59237 8.9007 2.59237 8.0993 3.0229 7.66913L3.02311 7.66892L7.16892 3.52311Z"
        strokeWidth="1.4"
      />
    </svg>
  );
};
